import { render, staticRenderFns } from "./AccountView.vue?vue&type=template&id=3ae07ed0&scoped=true"
import script from "./AccountView.vue?vue&type=script&lang=js"
export * from "./AccountView.vue?vue&type=script&lang=js"
import style0 from "./AccountView.vue?vue&type=style&index=0&id=3ae07ed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae07ed0",
  null
  
)

export default component.exports